module.exports = __webpack_public_path__ + "static/img/confetti.e49e2ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/confetti.png
// module id = 1ab7
// module chunks = 0